<div class="app-action-tablet-header">
    <sc-padding>
        <sc-flex stretchContent>
            <ng-container *ngFor="let station of actionTabletContext?.selectedStations, let i = index">
                <sc-content-spacer *ngIf="i>0"></sc-content-spacer>
                <app-action-tablet-header-station-tab [stationId]="station" [selected]="isStationSelected(station)"
                    (close)="closeStation($event)"
                    (select)="selectStation($event)"></app-action-tablet-header-station-tab>
            </ng-container>
            <sc-content-spacer grow></sc-content-spacer>
            <button mat-icon-button class="options-icon-button" (click)="chooseStation()">
                <sc-icon iconClass="fa-plus"></sc-icon>
            </button>
        </sc-flex>
    </sc-padding>
</div>
